import { useCallback } from "react";
import type { LayoutContextValue } from "@/components/layout/layout-provider";
import type { MasterLayoutData } from "@/components/layout/use-master-layout-data";
import type { SwitcherProject } from "@/components/panels/space-switcher";
import { ProjectContextMenuContent } from "@/components/panels/project-context-menu-content";

export function useMasterSwitcherContextMenuRenderers(
  data: MasterLayoutData,
  layout: LayoutContextValue,
) {
  const renderProjectContextMenu = useCallback(
    (project: SwitcherProject) => (
      <ProjectContextMenuContent
        project={project}
        onRename={(name) => void data.renameProject(project.id, name)}
        onSetColor={(projectId, color) =>
          void data.updateProjectColor(projectId, color)
        }
        onPin={(projectId) => void data.toggleProjectPinned(projectId)}
        onSettings={() =>
          layout.openSettings({
            page: "projects-project",
            args: { projectId: project.id, title: project.name },
          })
        }
        onDelete={(projectId) => void data.deleteProject(projectId)}
      />
    ),
    [data, layout],
  );

  return { renderProjectContextMenu };
}
